/* eslint-disable indent */
// components
import GridPageAbstract from '../../../GridPageAbstract';
import { NotificationStatusBulkIcon } from '../../../../icons-lib/bulkIcons';
import config from '../../../../config';
import {
    AddCircleWhiteLinearIcon,
    Edit1LinearIcon,
    SendLinearIcon,
    DocumentTextLinearIcon,
    TimerLinearIcon
} from '../../../../icons-lib';
import i18 from '../../../../i18';
import i18n from '../../../../i18';
import { MenuItem } from '@mui/material';
import React from 'react';

export default class MarketingCampaignsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'marketingCampaigns';
        this.Server = this.props.context.getState().server.marketingCampaigns;
        this.hideSearch = false;
        this.searchFields = ['campaignName'];

        this.headerStartIcon = NotificationStatusBulkIcon;
        this.bannerImage = config?.bannerImages?.transactions || '';

        this.hiddenColumns = config?.hiddenColumns?.marketingCampaigns || [];

        this.hideAddAction = true;
        this.hideEditAction = true;
        this.MenuDisplayType = 'menu';

        this.getHeaderActions = () => [
            {
                title: i18.t('actions.addMarketingCampaign'),
                icon: <AddCircleWhiteLinearIcon />,
                onClick: () =>
                    this.handleNavigate('/app/marketing-campaigns/add')
            }
        ];

        this.Head = [
            {
                id: 'imageUrl',
                label: 'image',
                alignRight: false,
                cell: 'ImagePreview',
                disableEditor: true
            },
            {
                id: 'campaignName',
                label: 'campaignName',
                alignRight: false,
                cell: 'Text',
                disableEditor: true
            },
            {
                id: 'status',
                label: 'status',
                alignRight: false,
                cell: 'Text',
                filterCell: 'Select',
                filterOptions: [
                    { value: 'DRAFT', label: 'Draft' },
                    { value: 'SCHEDULED', label: 'Scheduled' },
                    { value: 'SENT', label: 'Sent' },
                    { value: 'PROCESSING', label: 'Processing' },
                    { value: 'ON_HOLD', label: 'On Hold' }
                ],
                renderValue: (value) => {
                    switch (value?.toUpperCase()) {
                        case 'SENT':
                            return 'Sent';
                        case 'DRAFT':
                            return 'Draft';
                        case 'SCHEDULED':
                            return 'Scheduled';
                        case 'PROCESSING':
                            return 'Processing';
                        case 'ON_HOLD':
                            return 'On Hold';
                        default:
                            return value;
                    }
                },
                disableEditor: true
            },
            {
                id: 'audienceListUserNumber',
                label: 'totalRecipients',
                alignRight: false,
                cell: 'Text',
                disableEditor: true
            },
            {
                id: 'deliveryRate',
                label: 'deliveryRate',
                alignRight: false,
                cell: 'Text',
                filterCell: 'Range',
                filterRange: { min: 0, max: 100, step: 1, suffix: '%' },
                renderValue: (value) => (value ? `${value}%` : '-'),
                disableEditor: true
            },
            {
                id: 'clickRate',
                label: 'clickRate',
                alignRight: false,
                cell: 'Text',
                filterCell: 'Range',
                filterRange: { min: 0, max: 100, step: 1, suffix: '%' },
                renderValue: (value) => (value ? `${value}%` : '-'),
                disableEditor: true
            },
            {
                id: 'audienceListsNames',
                label: 'audienceLists',
                alignRight: false,
                cell: 'Text',
                filterCell: 'Text',
                disableEditor: true
            },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateModified',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }

    handleNavigate = (url) => {
        this.props.navigate(url);
    };

    hasMenuItems() {
        // Always show menu for marketing campaigns
        // because we have Edit button for all items
        // and Send button for items with suitable status
        return true;
    }

    handleSendItem = () => {
        const currentItemId = this.state.menuClickItemId;
        const selectedItem = this.List.find(
            (item) => item.id === currentItemId
        );

        if (selectedItem) {
            // Send campaign (now for all statuses)
            this.Server.send(currentItemId)
                .then(() => {
                    this.setState({
                        snackbarOpen: true,
                        alertText: i18n.t('notifications.campaignSentSuccess')
                    });
                    this.retrieveData();
                })
                .catch((error) => {
                    console.error('Error sending campaign:', error);
                    this.setState({
                        snackbarOpen: true,
                        alertText: i18n.t('notifications.campaignSentError')
                    });
                });
        }
    };

    handleDuplicateItem = async () => {
        const currentItemId = this.state.menuClickItemId;
        const selectedItem = this.List.find(
            (item) => item.id === currentItemId
        );

        if (selectedItem) {
            try {
                // Get full campaign data
                const campaignData = await this.Server.getById(currentItemId);

                if (campaignData.error === 'OK') {
                    // Create a copy without ID and with a new name
                    const duplicateData = {
                        ...campaignData.data,
                        campaignName: `${campaignData.data.campaignName} (Copy)`,
                        status: 'DRAFT'
                    };
                    delete duplicateData.id;
                    delete duplicateData.dateCreated;
                    delete duplicateData.dateModified;

                    const response = await this.Server.add(duplicateData);

                    if (response.error === 'OK') {
                        this.setState({
                            snackbarOpen: true,
                            alertText: i18n.t(
                                'notifications.campaignDuplicatedSuccess'
                            )
                        });
                        this.retrieveData();
                    } else {
                        throw new Error(response.error);
                    }
                } else {
                    throw new Error(campaignData.error);
                }
            } catch (error) {
                console.error('Error duplicating campaign:', error);
                this.setState({
                    snackbarOpen: true,
                    alertText: i18n.t('notifications.campaignDuplicatedError')
                });
            }
        }
    };

    handlePauseItem = async () => {
        const currentItemId = this.state.menuClickItemId;
        const selectedItem = this.List.find(
            (item) => item.id === currentItemId
        );

        if (selectedItem) {
            try {
                // Get full campaign data
                const campaignData = await this.Server.getById(currentItemId);

                if (campaignData.error === 'OK') {
                    // Update status to PAUSED or ON_HOLD
                    const updateData = {
                        ...campaignData.data,
                        status: 'ON_HOLD'
                    };

                    const response = await this.Server.update(
                        currentItemId,
                        updateData
                    );

                    if (response.error === 'OK') {
                        this.setState({
                            snackbarOpen: true,
                            alertText: i18n.t(
                                'notifications.campaignPausedSuccess'
                            )
                        });
                        this.retrieveData();
                    } else {
                        throw new Error(response.error);
                    }
                } else {
                    throw new Error(campaignData.error);
                }
            } catch (error) {
                console.error('Error pausing campaign:', error);
                this.setState({
                    snackbarOpen: true,
                    alertText: i18n.t('notifications.campaignPausedError')
                });
            }
        }
    };

    renderCustomMenuItems() {
        const currentItemId = this.state.menuClickItemId;
        const selectedItem = this.List.find(
            (item) => item.id === currentItemId
        );

        const menuItems = [
            <MenuItem
                key="send"
                onClick={() => {
                    this.handleCloseMenu();
                    this.handleSendItem();
                }}
            >
                <SendLinearIcon sx={{ mr: 2 }} />
                {i18n.t('buttons.send')}
            </MenuItem>,
            <MenuItem
                key="duplicate"
                onClick={() => {
                    this.handleCloseMenu();
                    this.handleDuplicateItem();
                }}
            >
                <DocumentTextLinearIcon sx={{ mr: 2 }} />
                {i18n.t('buttons.duplicate')}
            </MenuItem>,
            <MenuItem
                key="edit"
                onClick={() => {
                    this.handleCloseMenu();
                    this.handleNavigate(
                        `/app/marketing-campaigns/update/${currentItemId}`
                    );
                }}
            >
                <Edit1LinearIcon sx={{ mr: 2 }} />
                {i18n.t('buttons.edit')}
            </MenuItem>
        ];

        // Add Pause button for all campaigns (for debugging)
        // Later we can limit only for certain statuses
        // menuItems.splice(2, 0, // Insert before Edit
        //     <MenuItem
        //         key="pause"
        //         onClick={() => {
        //             this.handleCloseMenu();
        //             this.handlePauseItem();
        //         }}
        //     >
        //         <TimerLinearIcon sx={{ mr: 2 }} />
        //         {i18n.t('buttons.pause')}
        //     </MenuItem>
        // );

        return menuItems;
    }
}
